import cn from 'classnames';
import React, { type ReactNode } from 'react';
import { Text } from 'src/components/text/Text';
import { useLocale } from 'src/hooks/use-locale';

import styles from './LearnMoreHowItWorks.css';

interface Props {
  list?: Array<{ text: string; icon?: ReactNode }>;
  partnerCharges?: boolean;
  classNameRoot?: string;
}

export const LearnMoreHowItWorks = ({
  list,
  partnerCharges,
  classNameRoot,
}: Props) => {
  const t = useLocale();

  const listDefault: Props['list'] = [
    { text: t('choose_at_checkout_to_select_payment_plan') },
    {
      text: t('tabbySimple.enter_your_information'),
    },
    {
      text: t('depending_on_your_plan'),
    },
    { text: t('we_will_send_you_a_reminder') },
  ];

  const listResult = list || listDefault;

  return (
    <div
      className={cn(styles.LearnMoreHowItWorks, classNameRoot)}
      data-test="popup-how-it-works"
    >
      <Text
        as="h3"
        variant="h3"
        data-test="popup-how-it-works-title"
        className={styles.LearnMoreHowItWorks__Title}
      >
        {t('tabbySimple.how_it_works')}
      </Text>
      <ul className={styles.LearnMoreHowItWorks__List}>
        {listResult.map((item, i) => (
          <li
            key={item.text}
            className={styles.LearnMoreHowItWorks__Item}
            data-test={`popup-how-it-works-item-${i}`}
          >
            <span
              className={cn(styles.LearnMoreHowItWorks__Marker, {
                [styles.LearnMoreHowItWorks__Marker_icon]: !!item.icon,
              })}
            >
              {item.icon ?? (
                <Text as="span" variant="body2TightBold">
                  {i + 1}
                </Text>
              )}
            </span>
            <Text
              as="p"
              variant="body1Loose"
              className={styles.LearnMoreHowItWorks__Instruction}
              data-test={`popup-how-it-works-item-text-${i}`}
            >
              {item.text}
            </Text>
          </li>
        ))}
      </ul>
      {partnerCharges && (
        <div className={styles.LearnMoreHowItWorks__PartnerCharges}>
          <Text as="p" variant="body2Tight">
            {t('tabby_does_not_charge_any_additional_fees')}
          </Text>
        </div>
      )}
    </div>
  );
};
